import BrandLogo from './brand_icon_small.png'
import clutchGameLogo from './moola-hub-logo.png'
import provider1 from './provider-1.png'
import bitcoin from './bitcoin.png'
import goldICon from './coin.png'
import goldCoin25x25Icon from './gold-coin-25x25.png'
import teamIcon1 from './table-icon.png'
import heart from './heart.png'
import Fullscreen from './zoom.png'
import casino from './casino.png'
import AuthBackgroundPng from './signup-coins.png'
import RewardGraph from './reward-graph.png'
import RewardBox from './reward-box.png'
import earthIcon from './earth.png'
import liveGame from './live-img.png'
import eth from './eth.png'
import close from './close.png'
import Bonus from './bonus.png'
import Cashback from './cashback.png'
import Mini from './Mini.png'
import PokerGames from './poker-games.png'
import Promotion from './promotion.png'
import Community from './Community.png'
import chatAvtar from './chat-user.png'
import ecoSports from './clutch-1.png'
import ecoCasino from './clutch-2.png'
import ecoFutures from './clutch-3.png'
import dice from './dice.png'
import hotGames from './home-promotion-1.png'
import clutchWhitepaper from './home-promotion-2.png'
import vipRanked from './home-promotion-3.png'
import mine from './mine.png'
import mine2 from './mines.png'
import hilo from './hilo.png'
import coinFlip from './coin-flip.png'
import crash from './crash-card.jpg'
import casinoHeading from './casino-heading-ico.png'
import defaultGameImage from './defaultGameImage.png'
import americanFootball from './american-football.png'
import tennis from './tennis.png'
import baseball from './baseball.png'
import iceHockey from './ice-hockey.png'
import premierLeague from './premier-league.png'
import leagueOfLegends from './league-of-legends.png'
import formulaOne from './formulaOne.png'
import ClutchGameOn from './moola-logo-on.png'
import ProfileImg from './profileImg.png'
import plinko from './plinko.png'
import fifa from './fifa.png'
import mma from './mma.png'
import boxing from './boxing.png'
import counterStrike from './counter-strike.png'
import cricket from './cricket.png'
import dota from './dota.png'
import rugbyLeague from './rugby-league.png'
import rugbyUnion from './rugby-union.png'
import valorant from './valorant.png'
import golf from './golf.png'
import clutchWalletIcon from './clutch-wallet-icon.png'
import peopleIcon from './age-icon.png'
import crashHistoryIcon from './you-icon.png'
import mixCoin from './mix-coin.png'
import modalCashout from './modal-cashout.png'
import modalDown from './modal-down.png'
import modalInfo from './modal-info.png'
import modalMultiplier from './modal-multiplier.png'
import modalUp from './modal-up.png'
import coinFlipHeads from './heads.png'
import coinFlipTails from './tails.png'
import rollerCoaster from './vector.png'
import sideFox from './side-fox.png'
import googleCut from './google-cut.png'
import AffiliateCardOne from './affiliate-card-1.png'
import AffiliateCardTwo from './affiliate-card-2.png'
import AffiliateCardThree from './affiliate-card-3.png'
import AffiliateCardFour from './affiliate-card-4.png'
import AffiliateCardFive from './affiliate-card-5.png'
import rewardCards from './rewards-cards.png'
import rewardCoins from './rewards-coins.png'
import rewardStone from './rewards-stone.png'
import rewardBadge from './rewards-badge.png'
import rewardGiftBox from './rewards-giftbox.png'
import twitchCut from './twitch-cut.png'
import phantomCut from './phantom-cut.png'
import rewardsVisa from './rewards-visa.png'
import mPesaLogo from './m-pesa-logo.png'
import minusFilled from './minus_filled.png'
import coinflip from './coinflip.png'
import roulette from './roulette.png'
import blackjack from './blackjack.png'
import keno from './keno.png'

export {
  AffiliateCardOne,
  AffiliateCardTwo,
  AffiliateCardThree,
  AffiliateCardFour,
  AffiliateCardFive,
  BrandLogo,
  clutchGameLogo,
  provider1,
  dice,
  bitcoin,
  goldICon,
  goldCoin25x25Icon,
  googleCut,
  teamIcon1,
  heart,
  Fullscreen,
  casino,
  sideFox,
  AuthBackgroundPng,
  RewardGraph,
  RewardBox,
  earthIcon,
  liveGame,
  eth,
  close,
  Mini,
  Bonus,
  Cashback,
  PokerGames,
  Promotion,
  Community,
  chatAvtar,
  ecoSports,
  ecoCasino,
  ecoFutures,
  hotGames,
  clutchWhitepaper,
  vipRanked,
  mine,
  hilo,
  coinFlip,
  crash,
  casinoHeading,
  defaultGameImage,
  americanFootball,
  tennis,
  baseball,
  iceHockey,
  premierLeague,
  leagueOfLegends,
  formulaOne,
  ClutchGameOn,
  ProfileImg,
  plinko,
  fifa,
  mma,
  boxing,
  counterStrike,
  cricket,
  dota,
  rugbyLeague,
  rugbyUnion,
  valorant,
  golf,
  clutchWalletIcon,
  peopleIcon,
  crashHistoryIcon,
  mixCoin,
  modalCashout,
  modalDown,
  modalInfo,
  modalMultiplier,
  modalUp,
  coinFlipHeads,
  coinFlipTails,
  rollerCoaster,
  rewardCards,
  rewardCoins,
  rewardStone,
  rewardBadge,
  rewardGiftBox,
  twitchCut,
  phantomCut,
  rewardsVisa,
  mPesaLogo,
  minusFilled,
  coinflip,
  roulette,
  blackjack,
  keno,
  mine2
}
